import React from "react";
import { Link } from "react-router-dom";
import Icon, { IconName } from "./icons";
import { TONE } from "./tokens";
import { AccountStatus } from "./maps";

const KIND_ICON: Record<AccountStatus["kind"], IconName> = {
  approved: "checkCircle",
  review: "info",
  action: "alertTriangle",
};

const StatusBanner: React.FC<{ status: AccountStatus }> = ({ status }) => {
  const isAction = status.kind === "action";
  const tone = isAction
    ? { bg: TONE.action.bg, bd: TONE.action.bd, fg: TONE.action.fg, sub: "#8A6A3A", ic: "#C8932A" }
    : { bg: TONE.info.bg, bd: TONE.info.bd, fg: TONE.info.fg, sub: TONE.info.sub, ic: TONE.info.ic };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 13,
        background: tone.bg,
        border: `1px solid ${tone.bd}`,
        borderRadius: 12,
        padding: "14px 18px",
      }}
    >
      <Icon name={KIND_ICON[status.kind]} size={20} color={tone.ic} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <span style={{ fontWeight: 600, fontSize: 13.5, color: tone.fg }}>{status.title}</span>{" "}
        <span style={{ fontSize: 13, color: tone.sub }}>{status.note}</span>
      </div>
      {status.ctaLabel && status.ctaTo && (
        <Link
          to={status.ctaTo}
          style={{
            flexShrink: 0,
            whiteSpace: "nowrap",
            textDecoration: "none",
            fontWeight: 700,
            fontSize: 12.5,
            color: "#fff",
            background: isAction ? "#C8932A" : "#256141",
            borderRadius: 8,
            padding: "8px 16px",
          }}
        >
          {status.ctaLabel}
        </Link>
      )}
    </div>
  );
};

export default StatusBanner;
